/**
 * @GENERATED from Figma node 3638:52267
 */

import * as React from "react";
export type IconProps = Omit<React.SVGProps<SVGSVGElement>, "color">;
const PagesDark = (props: IconProps, ref: React.Ref<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    focusable={false}
    role="presentation"
    ref={ref}
    {...props}
  >
    <path
      fill="#FF8E21"
      fillRule="evenodd"
      d="M1 4.48c0-.337.274-.61.611-.61H22.39c.337 0 .611.273.611.61v1.648a.61.61 0 0 1-.611.611H1.61A.61.61 0 0 1 1 6.128zm0 6.696c0-.337.274-.61.611-.61H22.39c.337 0 .611.273.611.61v1.648a.61.61 0 0 1-.611.61H1.61a.61.61 0 0 1-.611-.61zm.611 6.085a.61.61 0 0 0-.611.611v1.647c0 .338.274.611.611.611h13.126a.61.61 0 0 0 .61-.61v-1.648a.61.61 0 0 0-.61-.611z"
      clipRule="evenodd"
    />
  </svg>
);
const ForwardRef = React.forwardRef(PagesDark);
export { ForwardRef as PagesDark };
